import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

const ProtectedLoginRoute: React.FC = () => {
    const { isAgreementChecked } = useAuth();

    if (!isAgreementChecked) {
        return <Navigate to="/" />;
    }

    return <Outlet />
};

export default ProtectedLoginRoute;
